<template>
  <div class="foodDetail">
    <!-- 轮播图 -->
    <van-swipe height="300" @change="onChange">
      <van-swipe-item v-for="(image, index) in foodDetail.files" :key="index">
        <img :src="image.path" class="banner-img" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator" v-if="foodDetail && foodDetail.files">
          {{ currentIndic + 1 }}/{{ foodDetail.files.length }}
        </div>
      </template>
    </van-swipe>
    <!-- 内容 -->
    <div class="food-info">
      <p class="title">{{ foodDetail.title }}</p>
      <p class="time-price">
        <span class="time sp1" v-if="foodDetail.openTime">{{
          foodDetail.openTime
        }}</span>
        <span class="cost sp1" v-if="foodDetail.costs"
          >￥{{ foodDetail.costs }}/人</span
        >
      </p>
      <div class="tags" v-if="foodDetail.tagsStr">
        <span
          :class="['tag', index !== 0 && 'tag-left']"
          v-for="(tag, index) in foodDetail.tagsStr.split('，')"
          :key="index"
          >{{ tag }}</span
        >
      </div>
      <div class="location">
        <img
          src="@/assets/images/icon_zuobiao_dgray.png"
          class="location-img"
        />
        <p class="location-text">{{ foodDetail.address }}</p>
      </div>
      <div class="food-desc" v-if="foodDetail.context">
        <img src="@/assets/images/jianjie.png" class="desc-img" />
        <p :class="[isShowMore ? 'desc-text-more' : 'desc-text']">
          {{ `“ ${foodDetail.context} ”` }}
        </p>
        <img
          v-if="!isShowMore"
          @click="showMore"
          src="@/assets/images/arrow_down.png"
          class="desc-more"
        />
      </div>
    </div>
    <!-- 评论 -->
    <comment-list type="food" :addParams="params" />
    <open-app />
  </div>
</template>

<script>
import { getFoodDetail } from '@/service/api'
import CommentList from '@/components/CommentList.vue'
import { getUrlParams } from '@/utils'
import OpenApp from '@/components/OpenApp.vue'
export default {
  components: { CommentList, OpenApp },
  data() {
    return {
      foodDetail: {},
      currentIndic: 0,
      isShowMore: false,
      //评论参数
      params: {
        foodId: '',
      },
    }
  },
  created() {
    this.params.foodId = getUrlParams('foodId')
  },
  mounted() {
    this._getFoodDetail()
  },
  methods: {
    onChange(index) {
      this.currentIndic = index
    },
    showMore() {
      this.isShowMore = true
    },
    //获取美食详情
    async _getFoodDetail() {
      // const id = '6a59001fc61537f915c360ae8617dc46'
      const id = getUrlParams('foodId')
      try {
        const res = await getFoodDetail(id)
        if (res) {
          // console.log('----美食详情---', res)
          this.foodDetail = res
        }
      } catch (error) {
        this.$toast(`${error}`)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.foodDetail {
  width: 100%;
  // padding-bottom: 70px;
  .banner-img {
    width: 100%;
    height: 100%;
  }
  //banner指示器
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 4px 10px;
    font-size: 12px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  .food-info {
    padding: 10px 15px;
    .title {
      font-size: 22px;
      font-weight: 600;
      margin-top: 10px;
    }
    //营业时间
    .time-price {
      .sp1 {
        font-size: 12px;
      }
      .time {
      }
      .cost {
        margin-left: 10px;
      }
    }
    //标签
    .tags {
      margin-top: 10px;
      font-size: 0;
      .tag {
        font-size: 12px;
        color: #f17c25;
        background-color: #fdf5e6;
        padding: 2px 5px;
        border-radius: 2px;
      }
      .tag-left {
        margin-left: 10px;
      }
    }
    //位置
    .location {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .location-img {
        width: 14px;
        height: 14px;
      }
      .location-text {
        flex: 1;
        font-size: 12px;
        padding-left: 10px;
      }
    }
    //
    .food-desc {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-color: #fdf5e6;
      padding: 12px 10px;
      border-radius: 8px;
      .desc-img {
        width: 16px;
        height: 16px;
      }
      .desc-text {
        flex: 1;
        padding-left: 10px;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .desc-text-more {
        flex: 1;
        padding-left: 10px;
        font-size: 13px;
      }
      .desc-more {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
